import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import {
  STOInsightsCoreContext as STOInsightsCoreContextType,
  STOMessageMediumTabs,
} from 'modules/intelligentInsights/stoInsights/types';

export const DEFAULT_STO_INSIGHTS_CORE_CONTEXT_STATE: STOInsightsCoreContextType = {
  isLoading: false,
  isError: false,
  isReady: false,
  insightsData: null,
  insightsErrorMessage: null,
  fetchCoreData: noop,
  selectedMedium: STOMessageMediumTabs.Email,
  setSelectedMedium: noop,
};

export const STOInsightsCoreContext = createContext<STOInsightsCoreContextType>(
  DEFAULT_STO_INSIGHTS_CORE_CONTEXT_STATE,
);
export const useSTOInsightsCoreContext = () => useContext(STOInsightsCoreContext);
